import Grid from '@mui/material/Grid';
import AutoCompleteMultiSelect from '../../../../packages/common-utilities/core/autocomplete-multiselect';
import { setProperty } from '../../../../packages/common-utilities/utils/misc';
import { useEffect } from 'react';

const FinanceV2AppConfig = ({
  config,
  userRoleHandler,
  formData,
  setFormData,
}) => {
  useEffect(() => {
    // For clearing out finance v2 config all together when finance v2 role is not selected all together
    if (!config?.showFinanceV2Config) {
      setProperty(['financeV2Roles'], [[]], setFormData);
    }
  }, [config?.showFinanceV2Config]);

  return (
    <>
      {config?.showFinanceV2Config ? (
        <>
          <Grid
            container
            md={12}
            sx={{
              mt: 2,
              display: 'flex',
              justifyContent: 'space-between',
              [`@media (max-width: 768px)`]: {
                gridGap: '5px',
              },
            }}
          >
            <Grid item md={5.5}>
              <AutoCompleteMultiSelect
                options={config.financeV2RoleList}
                onChange={(e, val) => {
                  userRoleHandler(e, val, 'financeV2Roles');
                }}
                value={formData?.financeV2Roles || []}
                placeholder="Select Finance V2 Roles"
                useDefaultVal={true}
                isValValArr={true}
              />
            </Grid>
          </Grid>
        </>
      ) : (
        <> </>
      )}
    </>
  );
};

export default FinanceV2AppConfig;
